import React, { useEffect, useRef, useState } from 'react';

import BasicButton from '../Common/Button/BasicButton';
import { ChevronRightIcon } from '../Icon';
import { colors } from '@/const/colors';
import { IMAGE_BASE_URL } from '@/const/url';
import '@/css/onBoadingStyle.css';
import Flicking, { EVENTS } from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';

type OnBoadingType = {
  onClickStart: () => void;
};

const DriveOnBoading = ({ onClickStart }: OnBoadingType) => {
  const flickingRef = useRef<Flicking>(null);
  const beforeOnboadingRef = useRef<boolean>(false);
  const [isShowBottomBtn, setIsShowButtomBtn] = useState<boolean>(false);
  const onBoadingDataList = [
    {
      title: '월별 매출 · 수익 계산',
      desc: '간단한 입력만으로 월별 매출과<br/>수익을 계산할 수 있어요.',
      imageUrl: `${IMAGE_BASE_URL}/drive_onboading1.jpg`,
    },
    {
      title: '간편한 미수금 관리',
      desc: '‘전체 수금처리’ 버튼으로 미수금도<br/>한 번에 처리가 가능해요.',
      imageUrl: `${IMAGE_BASE_URL}/drive_onboading2.jpg`,
    },
    {
      title: '자동 거리 계산',
      desc: '카카오 주소 연동 시스템으로<br/>상하차지 거리를 자동으로 계산해요.',
      imageUrl: `${IMAGE_BASE_URL}/drive_onboading3.jpg`,
    },
    {
      title: '주유비 자동 입력 기능',
      desc: '영수증 사진을 업로드하면<br/>주유비가 자동으로 입력돼요.',
      imageUrl: `${IMAGE_BASE_URL}/drive_onboading4.jpg`,
    },
    {
      title: '카테고리 관리 기능',
      desc: '지출・수익 카테고리를 직접<br/>편집하여 관리할 수 있어요.',
      imageUrl: `${IMAGE_BASE_URL}/drive_onboading5.jpg`,
    },
  ];
  const bullet = onBoadingDataList.map((item, index) => ({ isNow: index === 0 }));
  const [bulletList, setBulletList] = useState(bullet);
  const onClickBullet = (index: number) => {
    if (flickingRef.current) {
      flickingRef.current.moveTo(index).catch(() => void 0);
    }
  };

  useEffect(() => {
    if (flickingRef.current) {
      flickingRef.current.on(EVENTS.CHANGED, (event) => {
        const updatedBullet = onBoadingDataList.map((_, index) => ({ isNow: index === event.index }));
        setBulletList(updatedBullet);
      });
    }
  }, [onBoadingDataList]);

  const onClickGoToNext = () => {
    if (flickingRef.current) {
      flickingRef.current.next().catch(() => void 0);
    }
  };

  useEffect(() => {
    return () => {};
  }, []);

  const handleClickGoDriveHome = () => {
    localStorage.setItem('isShowDriveOnBoading', String(beforeOnboadingRef.current));
    onClickStart();
  };

  useEffect(() => {
    if (!flickingRef.current) return;

    const currentIndex = flickingRef.current.index;
    const lastIndex = flickingRef.current?.panels?.length - 1;

    setIsShowButtomBtn(currentIndex === lastIndex);
  }, [flickingRef.current?.index]);

  const handleClickSkip = () => {
    handleClickGoDriveHome();
  };

  return (
    <div className="min-w-[280px] max-w-[720px] w-full min-h-[540px] h-[100dvh] bg-grey-0 flex flex-col justify-center relative">
      <div
        className="flex absolute top-4 right-4 text-gray-7 text-[16px] z-[100000] cursor-pointer"
        onClick={handleClickSkip}
      >
        건너뛰기 <ChevronRightIcon color={colors.gray[7]} />
      </div>
      <div className="pt-2">
        <Flicking
          ref={flickingRef}
          align="center"
          circular={false}
          renderOnlyVisible={true}
          className="z-0 w-full"
          moveType="strict"
          circularFallback="bound"
        >
          {onBoadingDataList.map((data, index) => (
            <div
              className="flex flex-col items-center justify-center w-full h-full"
              key={index}
              onClick={() => onClickGoToNext()}
            >
              <div className="w-[248px] h-[316px]">
                <img src={data.imageUrl as string} alt="onboading_img" className="object-cover w-full h-full"></img>
              </div>
              <h2 className={`text-[28px] text-center leading-[32px] font-bold text-gray-9 mt-8`}>{data.title}</h2>
              <p
                className="text-[18px] leading-[20px] pt-3 pb-[17px] text-center text-gray-8"
                dangerouslySetInnerHTML={{ __html: data.desc }}
              ></p>
            </div>
          ))}
        </Flicking>
        <div className="z-10 flex justify-center py-8 cursor-pointer">
          {bulletList.map((data, index) => (
            <div
              key={index}
              className={`w-3 h-3 rounded-full cursor-pointer m-1  ${data.isNow ? 'bg-gray-7' : 'bg-gray-5'}`}
              onClick={(e) => onClickBullet(index)}
            ></div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 flex items-end justify-center py-8 cursor-pointer z-10 px-4 min-w-[280px] max-w-[720px] w-full">
        <BasicButton
          name={!!isShowBottomBtn ? '운행일지 작성하러 가기' : '다음'}
          bgColor={colors.primary[10]}
          borderColor={colors.primary[10]}
          textColor={colors.grey[0]}
          fontSize={16}
          height={48}
          fontWeight="bold"
          onClick={() => {
            if (isShowBottomBtn) {
              handleClickGoDriveHome();
            } else {
              onClickGoToNext();
            }
          }}
        />
      </div>
    </div>
  );
};

export default DriveOnBoading;
